import { auth } from "../Services/firebase";

export function signup(email, password, userName) {
   auth().createUserWithEmailAndPassword(email, password)
  .then(function(result) {
    return result.user.updateProfile({
      displayName: userName
    })
  }).catch(function(error) {
    alert(error.message);
    // console.log(error);
    return error
  });
}

export function signin(email, password) {
  return auth().signInWithEmailAndPassword(email, password);
}

export function signInWithGoogle() {
  const provider = new auth.GoogleAuthProvider();
  return auth().signInWithPopup(provider);
}

export function signInWithGitHub() {
  const provider = new auth.GithubAuthProvider();
  return auth().signInWithPopup(provider);
}

export function logout() {
  return auth().signOut();
}

export function currentUser() {
    return auth().currentUser;
  }

  export function userName() {
    return auth().currentUser.userName;
  }
